const getters = {
  userId: state => state.user.userId,
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  menu: state => state.app.menu,
  userDetal: state => state.user.userDetal,
  loadingMessage: state => state.app.loadingMessage,
  accessToken: state => state.user.accessToken,
  appToken: state => state.user.appToken
};
export default getters;
